<template>
  <div class="tendency">
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
    >
      <el-tab-pane
        label="交易额"
        name="1"
      ></el-tab-pane>
      <el-tab-pane
        label="交易笔数"
        name="2"
      ></el-tab-pane>
    </el-tabs>
    <div class="checkbox">
      <el-radio-group
        v-model="dateType"
        @change="selectDate"
      >
        <el-radio-button
          v-for="date in dateOptions"
          :label="date.value"
          :key="date.value"
        >{{ date.label }}</el-radio-button>
      </el-radio-group>
    </div>
    <el-row :gutter="10">
      <el-col :span="15">
        <div
          id="chart"
          style="height:360px;width:100%;"
        ></div>
      </el-col>
      <el-col :span="9">
        <el-table
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            type="index"
            label="排名"
            width="100"
          > </el-table-column>
          <el-table-column
            v-for="(item, index) in tableHeader"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :formatter="item.formatter"
          > </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable */
import macarons from "../theme/macarons";
import { getMonthDays } from "@/utils/index";

const echarts = require("echarts");

export default {
  props: {
    tendencyData: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      activeName: "1",
      dateType: 1,
      dateOptions: [
        {
          value: 1,
          label: "今日",
        },
        {
          value: 2,
          label: "本周",
        },
        {
          value: 3,
          label: "本月",
        },
        {
          value: 4,
          label: "本年",
        },
      ],
      tableHeader: [
        {
          prop: "merchantName",
          label: "商户名",
        },
        {
          prop: "totalAmt",
          label: "交易额",
          formatter(r, c, val) {
            return (val / 100).toFixed(2);
          },
        },
        {
          prop: "transactionNum",
          label: "交易笔数",
        },
      ],
      xMap: {
        1: [
          "00:00",
          "01:00",
          "02:00",
          "03:00",
          "04:00",
          "05:00",
          "06:00",
          "07:00",
          "08:00",
          "09:00",
          "10:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
        ],
        2: [
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六",
          "星期天",
        ],
        3: this.generateMonthDay(),
        4: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月",
        ],
      },
    };
  },

  computed: {
    xData() {
      if (!this.tendencyData.chartData) return [];
      return this.xMap[this.dateType];
    },

    yData() {
      if (!this.tendencyData.chartData) return [];
      let arr = new Array(this.xMap[this.dateType].length).fill(0)

      Object.keys(this.tendencyData.chartData).forEach((key) => {
        let index = this.dateType === 1 ? key : key-1
        if (this.activeName === "1") {
          arr[index] = (this.tendencyData.chartData[key].a / 100).toFixed(2)
        }
        if (this.activeName === "2") {
          arr[index] = this.tendencyData.chartData[key].n
        }
      });

      return arr
    },

    options() {
      return {
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: this.xData,
        },
        yAxis: {
          type: "value",
          max: function (value) {
            return value.max;
          },
          splitNumber: 4,
        },
        series: [
          {
            data: this.yData,
            type: "line",
          },
        ],
      };
    },

    tableData() {
      if (!this.tendencyData.chartData) return [];
      if (this.activeName === "1") {
        return this.tendencyData.rankData.amountRank;
      }
      if (this.activeName === "2") {
        return this.tendencyData.rankData.transNumRank;
      }
    },
  },

  watch: {
    tendencyData: {
      deep: true,
      handler() {
        this.drawChart();
      },
    },

    activeName() {
      this.drawChart();
    },
  },

  mounted() {},

  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },

    selectDate(val) {
      console.log(this.$parent);
      this.$parent.getBrokenLineChart(val);
    },

    drawChart() {
      this.chart = echarts.init(document.getElementById("chart"), "macarons");
      this.chart.setOption(this.options);
    },

    // echarts自适应
    selfAdaption() {
      const that = this;
      setTimeout(() => {
        window.onresize = () => {
          that.chart.resize();
        };
      }, 100);
    },

    generateMonthDay() {
      let dayLength = getMonthDays(
        new Date().getFullYear(),
        new Date().getMonth()
      );
      let arr = [];
      for (let i = 1; i < dayLength + 1; i++) {
        arr.push(new Date().getMonth() + 1 + "-" + i);
      }
      return arr;
    },
  },
};
</script>

<style lang="scss" scoped>
.tendency {
  position: relative;

  .checkbox {
    position: absolute;
    top: 0;
    right: 30px;
  }
}
</style>
